<rwidget-alert></rwidget-alert>
<div class="ticket" *ngIf="!env.IS_MOBILE_APP && !cart && !cartLoading; else shoppingCart">
    <rwidget-cart-empty *ngIf="env.EMPTY_CART_OPTIONS.SHOPPING_CART_TYPE === emptyCartOptions.BUY_PERIOD_OR_LOAD_MONEY">
        <div class="empty-status-shopping-cart-buttons__search">
            <button class="btn btn--big btn--maximal btn--primary" [routerLink]="'/purchase/wallet' | localize">
                {{ 'EMPTY_STATUS_LOAD_MONEY' | translate }}
            </button>
        </div>
        <div class="empty-status-shopping-cart-buttons__periodticket">
            <button class="btn btn--big btn--maximal btn--primary" [routerLink]="'/purchase-v2' | localize">
                {{ 'EMPTY_STATUS_BUY_PERIOD_TICKET' | translate }}
            </button>
        </div>
    </rwidget-cart-empty>

    <rwidget-cart-empty *ngIf="env.EMPTY_CART_OPTIONS.SHOPPING_CART_TYPE === emptyCartOptions.BUY_PERIOD">
        <div class="empty-status-shopping-cart-buttons__periodticket btn-center">
            <button class="btn btn--big btn--maximal btn--primary" [routerLink]="'/purchase-v2' | localize">
                {{ 'EMPTY_STATUS_BUY_PERIOD_TICKET' | translate }}
            </button>
        </div>
    </rwidget-cart-empty>
</div>
<!-- Shopping Cart Main Template -->
<ng-template #shoppingCart>
    <div class="bg-transparent md:min-h-[75vh] md:bg-white">
        <section class="main-grid">
            <!-- Desktop Sidebar: Steps Navigation -->
            <div class="hidden flex-col gap-12 md:flex">
                <p class="leading-12 w-64 text-4xl font-medium">{{ 'BUY_NEW_TICKET' | translate }}</p>
                <div
                    class="flex flex-col gap-6 border-t-2 border-solid border-opacity-5 pt-2 dark:border-contrast-yellow">
                    <div
                        class="flex items-center"
                        *ngFor="let section of steps; let index = index"
                        [ngClass]="{ 'opacity-50': index < steps.length - 1 }">
                        <ion-icon
                            class="mr-4 text-xl dark:filter-yellow"
                            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/step-desktop.svg"></ion-icon>
                        <ion-label class="text-base" [ngClass]="{ 'font-bold': index === steps.length - 1 }">
                            {{ section.title ? (section.title | translate) : (stepsDescription[index] | translate) }}
                        </ion-label>
                    </div>
                </div>
            </div>

            <!-- Main Content Area -->
            <main class="lg:col-start-2 lg:col-end-4">
                <div class="w-auto rounded-lg bg-grey-white_smoke dark:bg-contrast-black md:p-4">
                    <!-- Mobile Header: Back/Close Buttons -->
                    <div class="mb-4 bg-white shadow-md md:hidden">
                        <div
                            class="orb-app-light-dark:min-h-[4rem] relative flex min-h-[48px] flex-row items-center justify-center">
                            <ion-button
                                class="absolute left-0 mr-1"
                                *ngIf="
                                    !env.PURCHASE_FLOW?.HIDE_SHOPPING_CART_BACK_BUTTON &&
                                    (!env.IS_MOBILE_APP || cart?.tickets?.length) &&
                                    !isCartLocked()
                                "
                                [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                                (click)="handleBackClicked()"
                                fill="clear">
                                <ion-icon
                                    class="var-app-light-dark:text-primary gl-light:text-secondary text-xl dark:filter-yellow"
                                    [title]="'LOCAL_BTN_BACK' | translate"
                                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg"></ion-icon>
                            </ion-button>
                            <h1 class="var-app-light-dark:font-bold text-center text-base font-semibold leading-5">
                                {{ 'BUY_NEW_TICKET' | translate }}
                            </h1>
                            <ion-button
                                class="absolute right-1"
                                [attr.aria-label]="'LOCAL_BTN_CLOSE' | translate"
                                (click)="handleClosePurchasePage()"
                                fill="clear">
                                <ion-icon
                                    class="var-app-light:text-primary text-2xl dark:filter-yellow"
                                    [title]="'LOCAL_BTN_BACK' | translate"
                                    src="{{ assetsPath$ | async }}/img/explore/cross.svg"></ion-icon>
                            </ion-button>
                        </div>
                    </div>
                    <!-- Cart Content or Empty State -->
                    <ng-container *ngIf="!env.IS_MOBILE_APP || cart?.tickets?.length; else emptyState">
                        <div class="z-10 flex-1 overflow-y-auto" #cartContent>
                            <!-- Tickets in Cart Section -->
                            <div class="bg-white px-4 shadow-md">
                                <!-- Section Header with Remove Toggle -->
                                <div class="flex-align-center flex justify-between py-2">
                                    <h2
                                        class="bold m-0 py-2 text-xs font-semibold uppercase text-grey-dark dark:text-contrast-yellow"
                                        [class.normal-case]="env.REMOVE_UPPERCASE">
                                        {{ 'CART_YOUR_TICKET_IN_CART' | translate }}
                                    </h2>
                                    <button
                                        class="orb-app-light-dark:font-semibold var-app-light-dark:text-primary text-xs text-secondary dark:text-contrast-yellow"
                                        [ngClass]="{ 'cart-locked': isCartLocked() }"
                                        (click)="switchRemoveMode()">
                                        {{ (removeMode ? 'CART_DONE' : 'CART_REMOVE') | translate }}
                                    </button>
                                </div>
                                <mat-divider></mat-divider>

                                <!-- Ticket List -->
                                <div ridangoAriaList>
                                    <li
                                        class="flex list-none flex-row"
                                        *ngFor="let ticketGroup of sameTicketsGroup; let i = index">
                                        <div
                                            class="flex-align-center mr-2 flex h-full justify-between gap-4 self-center"
                                            *ngIf="ticket.removeMode">
                                            <ion-button
                                                class="next-button"
                                                [attr.aria-label]="'CART_REMOVE_TICKET_BUTTON' | translate"
                                                (click)="ticket.openDeleteTicketModal()"
                                                ridangoAutofocus
                                                fill="clear">
                                                <ion-icon
                                                    class="var-app-light:text-primary-danger orb-app-light:text-primary-danger text-primary dark:text-contrast-yellow"
                                                    src="{{
                                                        assetsPath$ | async
                                                    }}/img/purchase-flow-v2/cart/icon-delete.svg"></ion-icon>
                                            </ion-button>
                                        </div>
                                        <gl-shopping-cart-ticket
                                            class="flex-1"
                                            id="ticketInfo{{ i }}"
                                            #ticket
                                            [ticket]="ticketGroup.ticket"
                                            [totalPrice]="ticketGroup.totalPrice"
                                            [count]="ticketGroup.count"
                                            [productAreas]="productAreas"
                                            [removeMode]="removeMode"
                                            (ticketDelete)="handleDeleteTicket($event)"
                                            (valueCodeDelete)="handleDeleteValueCode($event)"
                                            ridangoParentAriaLabel
                                            tabindex="0">
                                        </gl-shopping-cart-ticket>
                                        <mat-divider></mat-divider>
                                    </li>
                                </div>

                                <mat-divider></mat-divider>

                                <!-- Value Codes Section (Cart Level) -->
                                <ng-container
                                    *ngIf="
                                        cart?.valueCodes?.length > 0 &&
                                        !env.PURCHASE_FLOW?.TICKET_CONF?.SHOPPING_CART?.SHOW_VALUE_CODES_PER_TICKET
                                    ">
                                    <div
                                        class="flex-align-center flex h-12 justify-between gap-4"
                                        *ngFor="let code of cart?.valueCodes">
                                        <ion-button
                                            class="remove-button"
                                            *ngIf="removeMode"
                                            (click)="openDeleteValueCodeModal(code)"
                                            fill="clear">
                                            <ion-icon
                                                class="text-primary"
                                                src="{{
                                                    assetsPath$ | async
                                                }}/img/purchase-flow-v2/cart/icon-delete.svg"></ion-icon>
                                        </ion-button>
                                        <p class="flex-1">{{ code.serialNumber }}</p>
                                        <p class="text-base font-bold">
                                            -{{ getPriceString(cart.price.discountAmount) }}
                                            {{ currency }}
                                        </p>
                                    </div>
                                    <mat-divider></mat-divider>
                                </ng-container>

                                <!-- Add Another Ticket Button -->
                                <ion-button
                                    class="m-0 w-full dark:filter-yellow"
                                    [attr.aria-label]="'CART_ADD_ANOTHER_TICKET' | translate"
                                    [disabled]="isAddButtonDisabled$ | async"
                                    (click)="handleAddTicketClicked()"
                                    size="large"
                                    fill="clear">
                                    <ion-icon
                                        class="var-app-light-dark:text-primary text-secondary"
                                        [ngClass]="{ 'cart-locked': isCartLocked() }"
                                        name="add"
                                        slot="start"></ion-icon>
                                    <ion-label
                                        class="var-app-light-dark:text-primary var-app-light-dark:font-semibold text-base font-bold normal-case text-secondary"
                                        [ngClass]="{ 'cart-locked': isCartLocked() }"
                                        >{{ 'CART_ADD_ANOTHER_TICKET' | translate }}
                                    </ion-label>
                                </ion-button>
                            </div>

                            <!-- Redeem Value Code Button -->
                            <ion-button
                                class="mx-0 my-4 w-full dark:filter-yellow"
                                *ngIf="env.PURCHASE_FLOW?.VALUE_CODE_ENABLED"
                                (click)="handleRedeemValueCode()"
                                size="large"
                                fill="clear">
                                <ion-icon
                                    class="pr-2 text-[2rem]"
                                    *ngIf="env.PURCHASE_FLOW?.SHOW_VALUE_CODE_BUTTON_ICON"
                                    aria-hidden="true"
                                    src="{{ assetsPath$ | async }}/img/purchase-flow-v2/cart/icon-value-code.svg">
                                </ion-icon>
                                <ion-label
                                    class="var-app-light-dark:text-primary var-app-light-dark:font-semibold text-base font-bold normal-case text-secondary"
                                    [ngClass]="{ 'cart-locked': isCartLocked() }">
                                    {{ 'CART_REDEEM_VALUE_CODE' | translate }}
                                </ion-label>
                            </ion-button>

                            <!-- ============================================
                                 PAYMENT METHODS SECTION
                                 ============================================ -->
                            <div
                                class="mb-2 bg-white py-2 shadow-md"
                                *ngIf="getCartPrice() > 0"
                                [ngClass]="
                                    env.IS_NEW_AFC &&
                                    paymentPortalMethodDetails?.cards &&
                                    paymentPortalMethodDetails.cards.length > 0
                                        ? 'pt-0'
                                        : 'pt-4'
                                "
                                [hidden]="!paymentPortalMethodDetails?.cards && !paymentPortalMethodDetails?.methods">
                                <h2
                                    class="bold mb-4 px-4 text-xs uppercase text-grey-dark dark:text-contrast-yellow"
                                    *ngIf="
                                        !env.IS_NEW_AFC ||
                                        (paymentPortalMethodDetails?.cards &&
                                            paymentPortalMethodDetails?.cards?.length === 0) ||
                                        paymentPortalMethodDetails?.cards === null
                                    "
                                    [class.normal-case]="env.REMOVE_UPPERCASE">
                                    {{ 'CART_PAYMENT_METHOD' | translate }}
                                </h2>

                                <!--swipeGesture - fix for VAS-3112 - other button action is activated after tapping the ion-segment-button-->
                                <div class="px-4" *ngIf="env.PURCHASE_FLOW?.PAYMENT_TYPE_COMPANY_ENABLED">
                                    <ion-segment
                                        class="mb-4 dark:filter-yellow"
                                        [(ngModel)]="selectedPayerType"
                                        [swipeGesture]="false"
                                        (ionChange)="onChangePayerType()"
                                        mode="ios"
                                        color="dark">
                                        <ion-segment-button
                                            [ngClass]="{ 'rounded-none': selectedPayerType !== payerType.personal }"
                                            [value]="payerType.personal">
                                            <ion-label
                                                class="text-base font-bold normal-case text-black"
                                                [ngClass]="{
                                                    'text-grey-zambezy': selectedPayerType !== payerType.personal
                                                }"
                                                >{{ 'CART_PAYMENT_PAYER_PERSONAL' | translate }}</ion-label
                                            >
                                        </ion-segment-button>
                                        <ion-segment-button
                                            [ngClass]="{ 'rounded-none ': selectedPayerType !== payerType.company }"
                                            [value]="payerType.company">
                                            <ion-label
                                                class="text-base font-bold normal-case text-black"
                                                [ngClass]="{
                                                    'text-grey-zambezy': selectedPayerType !== payerType.company
                                                }"
                                                >{{ 'CART_PAYMENT_PAYER_COMPANY' | translate }}</ion-label
                                            >
                                        </ion-segment-button>
                                    </ion-segment>
                                </div>

                                <!-- Personal Payment Methods -->
                                <ng-container
                                    *ngIf="
                                        selectedPayerType === payerType.personal &&
                                        env.PURCHASE_FLOW?.ENABLE_DETAILED_PAYMENT_METHODS
                                    ">
                                    <ng-container *ngTemplateOutlet="personalPaymentMethods"></ng-container>
                                </ng-container>

                                <!-- Personal Payment Methods (Simple) -->
                                <ng-container
                                    *ngIf="
                                        selectedPayerType === payerType.personal &&
                                        !env.PURCHASE_FLOW?.ENABLE_DETAILED_PAYMENT_METHODS
                                    ">
                                    <gl-single-payment-portal-method
                                        [method]="paymentPortalProviderMethod"
                                        [lang]="lang"></gl-single-payment-portal-method>
                                </ng-container>

                                <!-- Company Payment Methods -->
                                <div
                                    class="border-solid px-4"
                                    *ngIf="selectedPayerType === payerType.company"
                                    [class.border-t]="!preSelectedCompany">
                                    <ng-container *ngTemplateOutlet="companyPaymentMethods"></ng-container>
                                </div>
                            </div>
                        </div>

                        <!-- Corporate Balance Alerts -->
                        <div class="mx-3 mt-3" *ngIf="!enoughCorporateBalance() && selectedOrganization">
                            <ridango-ui-alert type="info">
                                <div>
                                    {{ 'NOT_ENOUGH_CORPORATE_CREDIT_BALANCE' | translate }}
                                </div>
                            </ridango-ui-alert>
                        </div>
                        <div
                            class="mx-3 mt-3"
                            *ngIf="
                                !isCorporateCreditActive() &&
                                selectedOrganization &&
                                selectedPayerType === PayerType.company
                            ">
                            <ridango-ui-alert type="info">
                                <div>
                                    {{ 'CORPORATE_CREDIT_NOT_ACTIVE' | translate }}
                                </div>
                            </ridango-ui-alert>
                        </div>

                        <!-- Mobile Checkout Section -->
                        <div class="mt-2 bg-white px-4 pb-8 md:hidden">
                            <!-- Total Amount -->
                            <div class="flex-align-center mb-0 flex h-14 justify-between pt-2">
                                <span>{{ 'CART_TOTAL_AMOUNT_PAYABLE' | translate }}</span>
                                <span class="text-xl font-bold">{{
                                    cart ? getPriceString(getCartPrice()) + ' ' + (env.CURRENCY || getCurrency()) : ''
                                }}</span>
                            </div>

                            <!-- Terms and Conditions -->
                            <ng-container *ngTemplateOutlet="purchaseTerms"></ng-container>

                            <mat-divider></mat-divider>

                            <!-- Proceed to Payment Button -->
                            <ion-button
                                class="cart-button mb-2 mt-4 w-full dark:text-contrast-black"
                                [attr.aria-label]="
                                    (isZeroSumCart ? 'CART_PROCEED_WITHOUT_PAYMENT' : 'CART_PROCEED_TO_PAYMENT')
                                        | translate
                                "
                                [disabled]="isProceedButtonDisabled"
                                (click)="handleProceedToPaymentClicked()"
                                size="large"
                                slot="end">
                                <ion-label
                                    class="orb-app-light:text-black orb-app-light-dark:font-semibold vl-app-light:text-black var-app-light:font-bold var-app-light:text-black orb-app-light:text-black text-base font-bold normal-case">
                                    {{
                                        (isZeroSumCart ? 'CART_PROCEED_WITHOUT_PAYMENT' : 'CART_PROCEED_TO_PAYMENT')
                                            | translate
                                    }}
                                </ion-label>
                                <ion-icon
                                    class="orb-app-light:text-black vl-app-light:text-black var-app-light:text-black orb-app-light:text-black"
                                    name="arrow-forward-outline"
                                    slot="end"></ion-icon>
                            </ion-button>
                        </div>
                    </ng-container>

                    <ng-template #emptyState>
                        <div class="z-10 flex-1 overflow-y-auto" *ngIf="firstInitCart">
                            <div class="bg-white px-4 shadow-md">
                                <div
                                    class="flex-align-center flex justify-between border-b border-solid border-black border-opacity-10 py-2 dark:border-contrast-yellow">
                                    <h2
                                        class="bold m-0 py-2 text-xs uppercase text-grey-dark dark:text-contrast-yellow"
                                        [class.normal-case]="env.REMOVE_UPPERCASE">
                                        {{ 'CART_YOUR_TICKET_IN_CART' | translate }}
                                    </h2>
                                </div>
                                <div class="my-16 flex flex-col items-center justify-center">
                                    <ion-icon
                                        class="h-16 w-16 dark:filter-yellow"
                                        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/cart/cart.svg"
                                        aria-disabled="true"></ion-icon>
                                    <p class="py-2 text-grey-dark dark:text-contrast-yellow">
                                        {{ 'CART_EMPTY_TITLE' | translate }}
                                    </p>
                                </div>
                                <ion-button
                                    class="m-0 w-full border-t border-solid border-black border-opacity-10 dark:filter-yellow dark:border-contrast-yellow"
                                    [attr.aria-label]="'BUY_NEW_TICKET' | translate"
                                    (click)="backToPurchaseFlow()"
                                    size="large"
                                    fill="clear">
                                    <ion-icon
                                        class="var-app-light:text-primary text-secondary"
                                        name="add"
                                        slot="start"></ion-icon>
                                    <ion-label
                                        class="var-app-light:text-primary text-base font-bold normal-case text-secondary">
                                        {{ 'BUY_NEW_TICKET' | translate }}
                                    </ion-label>
                                </ion-button>
                            </div>
                            <ion-button
                                class="m-0 w-full dark:filter-yellow"
                                [attr.aria-label]="'BACK_TO_TICKETS' | translate"
                                (click)="backToTicket()"
                                size="large"
                                fill="clear">
                                <ion-label
                                    class="var-app-light:text-primary text-base font-bold normal-case text-secondary">
                                    {{ 'BACK_TO_TICKETS' | translate }}
                                </ion-label>
                            </ion-button>
                        </div>
                    </ng-template>
                </div>

                <!-- Desktop Checkout Section -->
                <div class="mt-10 hidden md:block">
                    <!-- Total Amount -->
                    <div class="flex-align-center mb-4 flex h-14 justify-between">
                        <span class="ml-4">{{ 'CART_TOTAL_AMOUNT_PAYABLE' | translate }}</span>
                        <span class="text-xl font-bold">{{
                            cart ? getPriceString(getCartPrice()) + ' ' + (env.CURRENCY || getCurrency()) : ''
                        }}</span>
                    </div>

                    <!-- Terms and Conditions -->
                    <div class="px-4">
                        <ng-container *ngTemplateOutlet="purchaseTerms"></ng-container>
                    </div>

                    <!-- Navigation Buttons -->
                    <div class="flex h-32 items-center justify-between border-t-2 border-solid border-opacity-5 px-2">
                        <ion-button
                            class="text-base font-semibold normal-case leading-5"
                            *ngIf="env.IS_NEW_AFC && !env.PURCHASE_FLOW?.HIDE_SHOPPING_CART_BACK_BUTTON"
                            (click)="handleBackClicked()"
                            color="secondary"
                            fill="clear">
                            <ion-icon class="mr-3.5" name="arrow-back-outline"></ion-icon>
                            {{ 'PREVIOUS_BUTTON' | translate }}</ion-button
                        >
                        <div
                            class="invisible"
                            *ngIf="!env.IS_NEW_AFC || env.PURCHASE_FLOW?.HIDE_SHOPPING_CART_BACK_BUTTON"></div>
                        <ion-button
                            class="next-button cart-button lg:w-80"
                            [disabled]="isProceedButtonDisabled"
                            (click)="handleProceedToPaymentClicked()"
                            size="large">
                            <ion-label
                                class="orb-app-light:text-black tartu-light:text-white tallinn-light:text-white vl-app-light:text-black var-app-light:font-semibold var-app-light:text-primary whitespace-normal text-base font-bold normal-case dark:text-contrast-black">
                                {{
                                    (isZeroSumCart ? 'CART_PROCEED_WITHOUT_PAYMENT' : 'CART_PROCEED_TO_PAYMENT')
                                        | translate
                                }}
                            </ion-label>
                            <ion-icon
                                class="orb-app-light:text-black tartu-light:text-white tallinn-light:text-white vl-app-light:text-black var-app-light:text-primary dark:filter-black"
                                name="arrow-forward-outline"
                                slot="end"></ion-icon>
                        </ion-button>
                    </div>
                </div>
            </main>
        </section>
    </div>
</ng-template>

<!-- ============================================
     TEMPLATE DEFINITIONS
     ============================================ -->

<ng-template #purchaseTerms>
    <div
        class="mb-4 font-bold"
        *ngIf="
            ((env.PURCHASE_FLOW?.ENABLE_DETAILED_PAYMENT_METHODS ? selectedMethod : true) ||
                selectedPurpose ||
                isZeroSumCart) &&
            isShowTermsAndConditions
        ">
        <span (click)="toggleTermsAgreed()">
            <ion-checkbox
                class="terms-checkbox dark:solid-border -mb-0.5 mr-2 mt-2 dark:border-2 dark:border-contrast-yellow"
                [ngClass]="{ 'dark:bg-contrast-yellow': termsAgreed }"
                [checked]="termsAgreed"
                mode="md"
                slot="start"></ion-checkbox>
            <ion-label class="ml-0 inline">
                {{ 'READ_TERMS' | translate }}
            </ion-label>
        </span>
        <button
            class="gl-light:text-secondary appearance-none bg-transparent p-0 font-bold text-secondary hover:underline focus:underline dark:text-contrast-yellow"
            (click)="handleShowTermsConditions()"
            type="button">
            {{ 'WITH_TERMS_AND_CONDITIONS' | translate }}
        </button>
    </div>
</ng-template>

<!-- Personal Payment Methods Template (Detailed) -->
<ng-template #personalPaymentMethods>
    <!-- Saved Payment Cards -->
    <ng-container *ngIf="paymentPortalMethodDetails?.cards?.length">
        <div class="flex-align-center box-border flex h-12 justify-between px-4">
            <h2
                class="text-xs font-semibold uppercase text-grey-dark dark:text-contrast-yellow"
                [class.normal-case]="env.REMOVE_UPPERCASE">
                {{ 'SAVED_PAYMENT_METHODS' | translate }}
            </h2>
            <p
                class="orb-app-light-dark:font-semibold var-app-light-dark:text-primary text-xs text-secondary dark:text-contrast-yellow"
                (click)="onRemoveSavedMethodClick()">
                {{ 'CART_REMOVE' | translate }}
            </p>
        </div>
        <div class="flex-column box-border flex gap-4 border border-solid p-4 dark:border-contrast-yellow">
            <gl-ridango-saved-payment-method
                *ngFor="let card of paymentPortalMethodDetails.cards"
                [card]="card"
                [isSelected]="selectedMethod?.id === card.id"
                (methodSelected)="methodSelected($event)"></gl-ridango-saved-payment-method>
        </div>
        <div
            class="flex-align-center flex h-14 gap-6 px-4"
            (click)="showOtherPaymentMethods()"
            role="button"
            aria-haspopup="true">
            <img
                class="h-7 w-7 dark:filter-yellow"
                [ngClass]="{ 'rotate-90': showOtherPaymentPortalMethod }"
                src="{{ assetsPath$ | async }}/img/icon_more.svg"
                alt="" />
            <h2
                class="text-xs font-semibold uppercase text-grey-dark dark:text-contrast-yellow"
                [class.normal-case]="env.REMOVE_UPPERCASE">
                {{ 'OTHER_PAYMENT_METHODS' | translate }}
            </h2>
        </div>
    </ng-container>

    <!-- Other Payment Methods -->
    <div class="pb-4" *ngIf="showOtherPaymentPortalMethod">
        <gl-single-payment-method-v2
            *ngIf="paymentPortalMethodDetails?.methods?.length === 1"
            [method]="paymentPortalMethodDetails?.methods[0]"
            (methodSelected)="methodSelected($event)"></gl-single-payment-method-v2>
        <gl-multiple-payment-methods-v2
            *ngIf="paymentPortalMethodDetails?.methods?.length > 1"
            [methods]="paymentPortalMethodDetails?.methods"
            [selectedMethod]="selectedMethod"
            (methodSelected)="methodSelected($event)">
        </gl-multiple-payment-methods-v2>
    </div>
</ng-template>

<!-- Company Payment Methods Template -->
<ng-template #companyPaymentMethods>
    <!-- Saved Payment Methods Header -->
    <h2
        class="text-xs font-semibold uppercase text-grey-dark dark:text-contrast-yellow"
        *ngIf="preSelectedCompany"
        [class.normal-case]="env.REMOVE_UPPERCASE">
        {{ 'SAVED_PAYMENT_METHODS' | translate }}
    </h2>

    <!-- Organization List -->
    <ng-container *ngIf="organizations?.length && !selectedOrganization">
        <div class="flex-column flex gap-2 py-2" *ngFor="let organization of organizations">
            <gl-shopping-cart-company
                [organization]="organization"
                [selectedCompany]="selectedOrganization"
                [disabled]="preSelectedCompany && selectedOrganization?.company_name === organization.company_name"
                (organizationSelected)="onOrganizationSelected($event)"></gl-shopping-cart-company>
        </div>
    </ng-container>

    <!-- Selected Organization -->
    <div class="py-2" *ngIf="selectedOrganization">
        <gl-shopping-cart-company
            [organization]="selectedOrganization"
            [selectedCompany]="selectedOrganization"
            [disabled]="preSelectedCompany"
            (organizationSelected)="onOrganizationSelected($event)"></gl-shopping-cart-company>
    </div>

    <!-- Trip Purpose (Corporate Accounts) -->
    <div class="py-2" *ngIf="env.IS_NEW_AFC && (selectedAccountWithDisplayData$ | async)?.isCorporate">
        <p class="bold my-4 text-xs uppercase text-grey-dark dark:text-contrast-yellow">
            {{ 'CART_TRIP_PURPOSE' | translate }}
        </p>

        <!-- Purpose Selector -->
        <div
            class="flex-align-center flex justify-between rounded-lg border border-solid p-4 text-base dark:border-contrast-yellow"
            (click)="handleSelectPurposeClick()">
            <p>
                <span *ngIf="selectedPurpose?.title === tripPurposes.other; else purposeValue">
                    {{ 'CART_OTHER_PURPOSE' | translate }}
                </span>
                <ng-template #purposeValue>
                    <span class="bold">
                        {{ selectedPurpose?.title || ('CART_SELECT_PURPOSE' | translate) }}
                    </span>
                </ng-template>
            </p>
            <mat-icon class="arrow-drop-down material-icons-round">arrow_drop_down</mat-icon>
        </div>

        <!-- Other Purpose Text Area -->
        <ng-container *ngIf="selectedPurpose?.title === tripPurposes.other">
            <div
                class="m-auto mb-1 mt-4 w-11/12 rounded-lg border border-solid bg-grey-white_smoke pl-4 pr-4 pt-2 dark:border-contrast-yellow dark:bg-contrast-black"
                [class.border-red-500]="isCheckPurposeValue && isPurposeInputTouched && !purposeValueValidated">
                <textarea
                    class="w-full resize-none border-0 bg-grey-white_smoke outline-none focus:outline-none dark:bg-contrast-black"
                    [(ngModel)]="otherPurposeValue"
                    (input)="validatePurposeValue($event)"
                    (blur)="isPurposeInputTouched = true"
                    (focus)="isPurposeInputTouched = false"
                    rows="2"
                    placeholder="{{ 'CART_OTHER_PURPOSE' | translate }}"
                    maxlength="60"></textarea>
            </div>
            <div
                class="bold ml-4 text-xs text-grey-dark dark:text-contrast-yellow"
                *ngIf="!isCheckPurposeValue || !isPurposeInputTouched || purposeValueValidated; else validationError">
                {{ otherPurposeValue?.length || 0 }}/60
            </div>
            <ng-template #validationError>
                <mat-error class="bold ml-4 text-xs dark:text-contrast-yellow">
                    {{ 'CART_OTHER_PURPOSE_EMPTY' | translate }}
                </mat-error>
            </ng-template>
        </ng-container>
    </div>

    <!-- Add Company Button -->
    <mat-divider class="mt-2" *ngIf="!preSelectedCompany"></mat-divider>
    <ion-button
        class="m-0 w-full dark:filter-yellow"
        *ngIf="!selectedOrganization && !preSelectedCompany"
        [attr.aria-label]="'ADD_COMPANY' | translate"
        (click)="handleAddCompanyClicked()"
        color="secondary"
        size="large"
        fill="clear">
        <ion-icon class="text-secondary" slot="start" name="add"></ion-icon>
        <ion-label class="pt-1.5 text-base font-bold normal-case text-secondary">
            {{ 'ADD_COMPANY' | translate }}
        </ion-label>
    </ion-button>
</ng-template>
